module.exports = __webpack_public_path__ + "img/Gabon.a0a372a7.png";